import React, { useState, useEffect } from "react";
import ApiHandler from "../../ApiHandler.js";

import { isAuthenticated } from "../../state/account.js";
import { showRegister } from "../../state/models";

import { useRecoilState } from "recoil";

import * as utils from "./utils";

function Login(props) {

    const [message, setMessage] = useState("");

    const [, setIsAuthenticated ] = useRecoilState(isAuthenticated);

    const [, setShown] = useRecoilState(showRegister);


    const submit = async e => {
        e.preventDefault();

        setMessage("Logging you in...");

        const form = e.target;

        const data = Object.fromEntries([...new FormData(form)]);

        const res = await ApiHandler.get("/anime/login", {
            method: "POST",
            body: JSON.stringify(data)
        });

        if (!res?.error) {
            utils.saveCredentials(...Object.values(res.payload))

            setIsAuthenticated(true);
            setShown(false);
        }

        setMessage(res.message);

    }

    useEffect(() => {
        setMessage("")
    }, [setMessage]);

    return <>
        <div style={{
            display: props.shown ? "block" : "none"
        }} class="register">
            <form onSubmit={submit}>
                <div class="form-header">
                    <h1>Login</h1>
                </div>
                <div class="form-inputs">
                    <div className="input-cont">
                        <input required minLength={2} maxLength={32} className="searchinput" type="text" name="username" placeholder="Username" />
                    </div>
                    <div className="input-cont">
                        <input required minLength={6} maxLength={99} className="searchinput" type="password" name="password" placeholder="Password" />
                    </div>
                    <div className="input-cont">
                        <a onClick={ props.showRegister } href="#login">Don't have an account?</a>
                    </div>
                    <div className="input-cont">
                        <button className="submit-button">
                            Login
                        </button>
                    </div>
                    <div className="input-cont">
                        {message}
                    </div>
                </div>
            </form>
        </div>
    </>;

}

export default Login;